<template>
    <v-app>
        <v-app-bar app color="#231f20" dark height="64">
            <v-layout justify-space-between fill-height align-center>
                <v-flex sm6 md3>
                    <LogoLarge />
                </v-flex>
                <v-flex shrink>
                    <span class="white--text">Viewing shared case</span>
                </v-flex>
            </v-layout>
        </v-app-bar>
        <v-main>
            <slot />
        </v-main>
    </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import LogoLarge from '@/components/LogoLarge.vue'

export default Vue.extend({
    components: {
        LogoLarge
    }
})
</script>